module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PaySuccessView.js"));
	}, "PaySuccessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PaySuccessView!./src/pages/Shop/PayMent/PaySuccess/PaySuccessView.js
// module id = 871
// module chunks = 438